// Constructor.
// Create new Dklab_Realplexor object.
callpy_global.Dklab_Realplexor_Loader = {
    // Maximum bounce count.
    JS_MAX_BOUNCES: 10,

    // Reconnect delay.
    JS_WAIT_RECONNECT_DELAY: 0.01,

    // Realplexor WAIT url parts.
    //JS_WAIT_URI: '$JS_WAIT_URI',
    JS_WAIT_URI: callpy_global.rplx_server,

    // Realplexor normal WAIT timeout (seconds).
    JS_WAIT_TIMEOUT: 10,

    JS_IDENTIFIER: 'identifier',

    // It debug mode turned on?
    JS_DEBUG: 1,

    // Count of sequential bounces.
    _bounceCount: 0,

    // Namespace to use.
    _namespace: null,

    // Previous request time.
    _prevReqTime: null,

    // Previously used xmlhttp.
    _lastXmlhttp: null,

    // For IE8/IE9
    _isXDomain: false,

    // Pairs of [cursor, [ callback1, callback2, ... ]] for each ID.
    // Callbacks will be called on data ready.
    _ids: {},

    // Work-around for stupid IE. Unfortunately IE cannot catch exceptions
    // thrown from a callback created in a different frame, so we run such
    // callbacks wrapped by _callAndReturnException function. This
    // function is passed from the parent frame.
    _callAndReturnException: null,

    // Return the parent's document.
    _doc: function() {
        //return parent.document;
        return document;
    },

    // Create a new XMLHttpRequest object.
    _getXmlHttp: function() {
        var xmlhttp;
        if (typeof XMLHttpRequest != 'undefined') {
            xmlhttp = new XMLHttpRequest();
            if (window.XDomainRequest) { //cross-domain requests for IE8/9
                //if (!window.XDomainRequest) throw new Error("Cross-domain is not supported");
                xmlhttp = new XDomainRequest();
                this._isXDomain = true;
            }
        }
        if (!xmlhttp) try {
            xmlhttp = new ActiveXObject("Msxml2.XMLHTTP");
        } catch (e) {
        }
        if (!xmlhttp) try {
            xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
        } catch (e) {
        }
        return xmlhttp;
    },

    // Log a debug message.
    _log: function(msg, func) {

        if (!this.JS_DEBUG) return;
        if (window.console) {
            if (!func) func = "log";
            var multiline = false;
            if ((""+msg).match(/^([^\r\n]+)\r?\n([\s\S]*)$/)) {
                var first = RegExp.$1, second = RegExp.$2;
                if (m_callpy.m_logger.groupCollapsed) {
                    m_callpy.m_logger.groupCollapsed(first);
                    m_callpy.m_logger[func](second + "\n");
                    m_callpy.m_logger.groupEnd();
                } else {
                    m_callpy.m_logger.info(first);
                    m_callpy.m_logger[func](second + "\n");
                }
            } else {
                m_callpy.m_logger[func](msg);
                if (func=='error'){
                }
            }
        }

    },

    // Log an error message.
    _error: function(prefix, msg) {
        this._log(prefix, "error");
        this._log(msg);
    },

    // Process a single part.
    _processPart: function(part) {
        var errors = 0;

        // Extract IDs.
        var pairs = part.ids;
        if (pairs == null) {
            throw "Cannot find \"ids\" property within the response part";
        }

        // Extract data.
        var data = part.data;
        if (data == undefined) {
            throw "Cannot find \"data\" property within the response part";
        }

        // Process parts one after another.
        for (var id in pairs) if (pairs.hasOwnProperty(id)) {
            var cursor = pairs[id];
            // Strip namespace prefix.
            if (this._namespace != null) {
                if (id.indexOf(this._namespace) == 0) {
                    id = id.substring(this._namespace.length);
                }
            }
            if (!this._ids[id]) {
                this._ids[id] = { cursor: null, callbacks: [] };
            }
            var item = this._ids[id];
            item.cursor = cursor; // do not call parseFloat here! else you loose precision
            for (var j = 0; j < item.callbacks.length; j++) {
                var e = this._callAndReturnException(item.callbacks[j], [data, id, item.cursor]);
                if (e) {
                    this._error("Error executing callback #" + j + " for ID " + id + ": " + e, "Data:\n" + data);
                    errors++;
                }
            }
        }
        return errors;
    },

    // Parse multipart response text and return list of parts.
    _parseResponseTextIntoParts: function(text) {
        if (!text.match(/^\s*\[[\s\S]*\]\s*$/i)) {
            throw "Response is not a complete JSON";
        }
        var parts;
        eval("parts = " + text);
        return parts;
    },

    // Process the response data.
    _processResponseText: function(text) {
        // Safary bug: responseText sometimes contain headers+body, not only body!
        // So cat before the first "[".
        text = text.replace(/^[\s\S]*?(?=\[)/g, '');
        this._log("Received response:\n" + text);
        // Parse.
        var parts = this._parseResponseTextIntoParts(text);
        // Process.
        var errors = 0;
        for (var i = 0; i < parts.length; i++) {
            errors += this._processPart(parts[i]);
        }
        return errors;
    },

    // Called on response arrival.
    _onresponse: function(text) {
        var nextQueryDelay = Math.round(this.JS_WAIT_RECONNECT_DELAY * 1000);

        // Work-around to handle page unload. In case of this handler is executed after
        // the page is partly unloaded, do nothing, just return.
        try {
            if (!this._doc().body) return;
        } catch (ex) {
            return;
        }

        // Run the query.
        var errors = 0;
        try {
            // Empty response typically means that there is no error, but
            // server WAIT timeout expired and we need to reconnect.
            // But we exit via exception to check: is it a bounce or not.
            if (text.match(/^\s*$/)) {
                text = "";
                throw "Empty response";
            }
            this._processResponseText(text);
            this._bounceCount = 0;
        } catch (e) {
            var t = new Date().getTime();
            if (t - this._prevReqTime < this.JS_WAIT_TIMEOUT / 2 * 1000) {
                // This is an unexpected disconnect (bounce).
                this._bounceCount++;
                this._log("Bounce detected (bounceCount = " + this._bounceCount + ")");
            } else {
                this._log("Disconnect detected");
            }
            if (text != "") {
                this._error(e.message? e.message : e, "Response:\n" + text);
            }
            this._prevReqTime = t;
        }

        // Calculate next query delay.
        if (this._bounceCount > this.JS_MAX_BOUNCES) {
            // Progressive delay.
            var progressive = this._bounceCount - this.JS_MAX_BOUNCES + 2;
            nextQueryDelay = 1000 + 500 * progressive * progressive;
            if (nextQueryDelay > 15000) nextQueryDelay = 15000;
        }

        // Schedule next query, but only if there was no other request
        // performed (e.g. via execute() call) within the callback.
        if (!this._lastXmlhttp) {
            this._log("Next query in " + nextQueryDelay + " ms");
            if (m_callpy.m_storage) {
                /*
                 if (new Date().getTime() - m_callpy.m_storage.storage.lastSave > 30000){
                 window.location.href = window.location.href;
                 }
                 */

                //TODO: подумать, чтобы запись в LS всегда была только с одной вкладки (даже если ни одна не активна)
                if (m_callpy.m_storage.activeTab || 1==1) {
                    m_callpy.m_storage.storage.lastSave = new Date().getTime();
                    localStorage.setItem("callpy_data", JSON.stringify(m_callpy.m_storage.storage));
                    localStorage.setItem("callpy_lastRpx", m_callpy.m_storage.storage.lastSave);
                }else{
                    m_callpy.m_storage.storage.lastSave = new Date().getTime();
                }

            }
            var th = this;
            setTimeout(function() { th._loopFunc() }, nextQueryDelay);
        }
    },

    // Make value for identifier=... argument.
    _makeRequestId: function() {
        var parts = [];
        for (var id in this._ids) if (this._ids.hasOwnProperty(id)) {
            var v = this._ids[id];
            if (!v.callbacks.length) continue;
            parts.push(
                (v.cursor !== null? v.cursor + ":" : "") +
                    (this._namespace != null? this._namespace : "") + id
            );
        }
        return parts.join(",");
    },

    // Loop function.
    _loopFunc: function() {
        if (window.navigator.userAgent.indexOf("Lighthouse") !== -1) return;
        var requestId = this._makeRequestId();
        if (!requestId.length) return;
        var idParam = this.JS_IDENTIFIER + '=' + requestId;
        var url = null, postData = null;
        if (idParam.length + this.JS_WAIT_URI.length < 1700) {
            // GET method is only for not too long URLs.
            url = this.JS_WAIT_URI + '?' + idParam;
            url += "&ncrnd=" + (new Date().getTime()); // for stupid IE
        } else {
            // For very long IDs list - use POST method (always trail
            // the data with "\n", because else identifier=... will not
            // be recognized).
            url = this.JS_WAIT_URI;
            postData = idParam + "\n";
        }

        var xmlhttp = this._getXmlHttp();
        if (!xmlhttp) {
            this._error("No XMLHttpRequest found!");
            return;
        }

        var th = this;
        xmlhttp.open(postData? 'POST' : 'GET', url, true);
        if (!th._isXDomain){
            xmlhttp.onreadystatechange = function() {
                if (xmlhttp.readyState != 4) return;
                if (!th._lastXmlhttp) return; // abort() called
                th._lastXmlhttp = null;
                th._onresponse("" + xmlhttp.responseText);
                th = null;
            }
        }else{
            xmlhttp.onload = function() {
                if (!th._lastXmlhttp) return; // abort() called
                th._lastXmlhttp = null;
                th._onresponse("" + xmlhttp.responseText);
                th = null;
            }
        }
        xmlhttp.send(postData);
        this._prevReqTime = new Date().getTime();
        this._lastXmlhttp = xmlhttp;
    },

    // Run the polling process.
    // Argument structure: { id: { cursor: NNN, callbacks: [ callback1, callback2, ... ] } }
    // Second parameter must accept a function which will be called to
    // call parent's callbacks (it is needed for IE, to not to loose
    // exceptions thrown from a different frame).
    execute: function(callbacks, callAndReturnException, namespace) {
        var th = this;
        window.onunload = function() {
            // This is for IE7: it does not abort the connection on unload
            // and reaches the connection limit.
            try {
                if (th._lastXmlhttp) {
                    th._lastXmlhttp.onreadystatechange = function(){};
                    th._lastXmlhttp.abort();
                    th._lastXmlhttp = null;
                }
            } catch (e) {}
        }
        if (this._lastXmlhttp) {
            var xhr = this._lastXmlhttp;
            this._lastXmlhttp = null;
            xhr.onreadystatechange = function(){};
            xhr.abort();  // abort() does not make bounce if this._lastXmlhttp is null
        }
        this._namespace = namespace && namespace.length? namespace : null;
        this._ids = callbacks;
        this._callAndReturnException = callAndReturnException;
        this._loopFunc();
    },

    // Prepare Realplexor to execution.
    prepare: function() {
        if (!document.location.search.match(/HOST=([^&]+)/)) {
            //this._error("IFRAME src attribute must contain HOST=... specifier - parent's host name");
            //return;
        }
        //document.domain = RegExp.$1;
    }
};
//Dklab_Realplexor_Loader.prepare();

callpy_global.Dklab_Realplexor = function()
{
    var _this = this;

    this.get_namespace_rpx = function(site_id, domain)
    {
        //var s = 'abcdefghijklmnopqrstuvwxyz';
        if (domain == callpy_global.callpy_domain) return "callpy";
        else if (domain && domain.indexOf("."+callpy_global.callpy_domain)!=-1) return "callpy";
        else return "callpy";
        //else return "site" + s[site_id % 24];
    }

    this.init = function(fullUrl, namespace, viaDocumentWrite)
    {
        // Current JS library version.
        var VERSION = "1.32";

        // Detect current page hostname.
        var host = document.location.host;

        // Assign initial properties.
        if (!_this._registry) _this._registry = {}; // all objects registry
        _this.version = VERSION;
        _this._map = {};
        _this._realplexor = null;
        _this._namespace = namespace;
        _this._login = null;
        _this._iframeId = "mpl" + (new Date().getTime());
        _this._iframeTag =
            '<iframe'
                + ' id="' + _this._iframeId + '"'
                + ' onload="' + 'Dklab_Realplexor' + '._iframeLoaded(&quot;' + _this._iframeId + '&quot;)"'
                + ' src="' + fullUrl + '?identifier=IFRAME&amp;HOST=' + host + '&amp;version=' + _this.version + '"'
                + ' style="position:absolute; visibility:hidden; width:200px; height:200px; left:-1000px; top:-1000px"' +
                '></iframe>';
        _this._iframeCreated = false;


        // Register __this object in the registry (for IFRAME onload callback).
        _this._registry[_this._iframeId] = _this;

        // Validate realplexor URL.
        if (!fullUrl.match(/^\w+:\/\/([^/]+)/)) {
            throw 'Dklab_Realplexor constructor argument must be fully-qualified URL, ' + fullUrl + ' given.';
        }
        var mHost = RegExp.$1;
        if (mHost != host && mHost.lastIndexOf("." + host) != mHost.length - host.length - 1) {
            //throw 'Due to the standard XMLHttpRequest security policy, hostname in URL passed to Dklab_Realplexor (' + mHost + ') must be equals to the current host (' + host + ') or be its direct sub-domain.';
        }

        // Create IFRAME if requested.
        if (viaDocumentWrite) {
            document.write(_this._iframeTag);
            _this._iframeCreated = true;
        }

        // Allow realplexor's IFRAME to access outer window.
        //document.domain = host;
    };

    this._iframeLoaded = function()
    {
        var th = _this;

        th._realplexor = callpy_global.Dklab_Realplexor_Loader;

        th._realplexor.execute(
            _this._map,
            _this._callAndReturnException,
            (_this._login != null? _this._login + "_" : "") + (_this._namespace != null? _this._namespace : ""));

    };

// Set active login.
    this.logon = function(login) {
        _this._login = login;
    };

// Set the position from which we need to listen a specified ID.
    this.setCursor = function(id, cursor) {
        if (!_this._map[id]) _this._map[id] = { cursor: null, callbacks: [] };
        _this._map[id].cursor = cursor;
        return _this;
    };

// Subscribe a new callback to specified ID.
// To apply changes and reconnect to the server, call execute()
// after a sequence of subscribe() calls.
    this.subscribe = function(id, callback) {
        if (!_this._map[id]) _this._map[id] = { cursor: null, callbacks: [] };
        var chain = _this._map[id].callbacks;
        for (var i = 0; i < chain.length; i++) {
            if (chain[i] === callback) return _this;
        }
        chain.push(callback);
        return _this;
    };

// Unsubscribe a callback from the specified ID.
// You do not need to reconnect to the server (see execute())
// to stop calling of this callback.
    this.unsubscribe = function(id, callback) {
        if (!_this._map[id]) return _this;
        if (callback == null) {
            _this._map[id].callbacks = [];
            return _this;
        }
        var chain = _this._map[id].callbacks;
        for (var i = 0; i < chain.length; i++) {
            if (chain[i] === callback) {
                chain.splice(i, 1);
                return _this;
            }
        }
        return _this;
    };


// Reconnect to the server and listen for all specified IDs.
// You should call this method after a number of calls to subscribe().
    this.execute = function() {
        // Control IFRAME creation.
        if (!_this._iframeCreated) {
            //m_callpy.m_loader.load_script("http://rp."+callpy_global.callpy_domain + '?identifier=IFRAME&HOST=' + document.location.host + '&version=' + _this.version,document.body, _this._iframeLoaded);
            _this._iframeCreated = true;
        }
        _this._iframeLoaded();

    };

// This is a work-around for stupid IE. Unfortunately IE cannot
// catch exceptions which are thrown from the different frame
// (in most cases). Please see
// http://blogs.msdn.com/jaiprakash/archive/2007/01/22/jscript-exceptions-not-handled-thrown-across-frames-if-thrown-from-a-expando-method.aspx
    this._callAndReturnException = function(func, args) {
        try {
            func.apply(null, args);
            return null;
        } catch (e) {
            return "" + e;
        }
    }
};


// Static function.
// Called when a realplexor iframe is loaded.
